import React from "react";
import card1 from "../../Assets/img/Rectangle 1447.svg";
import card2 from "../../Assets/img/Rectangle 1451.svg";
import card3 from "../../Assets/img/Rectangle 1449.svg";
import card4 from "../../Assets/img/Rectangle 1452.svg";
import card5 from "../../Assets/img/Rectangle 1448.svg";
import card6 from "../../Assets/img/Rectangle 1450.svg";
import arrowIcon from "../../Assets/img/arrows (1) 1.svg";

const CardSection = () => {
  const cards = [
    { img: card1, title: "Red Flags to Avoid When Hiring" },
    { img: card3, title: "Stand Out with a Strong Resume" },
    { img: card5, title: "What Employers Should Know About 2025" },
    { img: card2, title: "The Role of Cultural Fit in Recruitment" },
    { img: card4, title: "Recruiting Top Talent from Anywhere" },
    { img: card6, title: "From Application to Offer: Job Search Guide" },
  ];

  // Split cards into 3 columns
  const columns = [[], [], []];
  cards.forEach((card, index) => {
    columns[index % 3].push(card);
  });

  return (
    <section className="card-3 py-lg-5">
      <div className="container">
        <h3 className="text-center fw-semibold">
          Insights & Advice for Employers and Talent
        </h3>
        <p className="text-center mb-4">
          Your go-to resource for recruitment insights, career advice, and workforce trends — powered by real hiring experience.
        </p>

        <div className="row g-4">
          {columns.map((col, colIndex) => (
            <div className="col-sm-6 col-lg-4" key={colIndex}>
              {col.map((card, index) => (
                <div className="custom-card rounded-3  bg-white mb-4" key={index}>
                  <img
                    src={card.img}
                    alt={card.title}
                    className="img-fluid rounded-3"
                  />
                  <div className="card-footer-grid">
                    <h5 className="card-title">{card.title}</h5>
                    <img
                      src={arrowIcon}
                      alt="Arrow"
                      className="arrow-icon"
                    />
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CardSection;
